const selectors = {
  block: '[data-form-wrapper]',
  recipientSelector: '[data-recipient-selector]',
  hiddenInput: 'input[name="input_7"]',
  radio: 'input[type="radio"]',
};

const getCheckedRadio = (block) =>
  block.querySelector(`${selectors.recipientSelector} ${selectors.radio}:checked`);

const updateEmail = (block, email) => {
  const input = block.querySelector(selectors.hiddenInput);
  if (input) input.value = email;
};

const observeFormRerender = (block) => {
  const observer = new MutationObserver(() => {
    const checked = getCheckedRadio(block);
    if (checked) updateEmail(block, checked.value);
  });

  observer.observe(block, { childList: true, subtree: true });
};

const initBlock = (block) => {
  const selector = block.querySelector(selectors.recipientSelector);

  if (!selector) return;

  const defaultRadio = getCheckedRadio(block);
  if (defaultRadio) updateEmail(block, defaultRadio.value);

  selector.addEventListener('change', (e) => {
    if (e.target.name === 'representative_choice') {
      updateEmail(block, e.target.value);
    }
  });

  observeFormRerender(block);
};

document.addEventListener(
  'DOMContentLoaded',
  () => {
    const blocks = document.querySelectorAll(selectors.block);
    blocks?.forEach(initBlock);
  },
  { once: true }
);
